import React, { useEffect, useState } from 'react';
import Main from '../Main';
import {
  Box,
  Card,
  CardContent,
  Grid,
  Radio,
  FormControlLabel,
  CardActionArea,
  Button,
  Typography,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import {
  getAddressById,
  setCurrentAddress,
} from '../../../Redux/SellerRedux.js';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import NewAddress from './NewAddress.js';

function Address(props) {
  const {view}= props || {};
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem('user'));
  const { userAddress, statusUpdate } = useSelector(
    (state) => state.sellerRedux
  );
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedAddressData, setSelectedAddressData] = useState(null);
  const [checkedAddresses, setCheckedAddresses] = useState({});

  useEffect(() => {
    dispatch(getAddressById(user.userId));
  }, [dispatch, statusUpdate]);

  useEffect(() => {
    if (userAddress?.address?.length > 0) {
      const initialCheckedState = userAddress.address.reduce((acc, addr) => {
        acc[addr._id] = addr.isChecked;
        return acc;
      }, {});
      setCheckedAddresses(initialCheckedState);
      const selectedIndex = userAddress.address.findIndex(
        (addr) => addr.isChecked
      );
      if (selectedIndex !== -1) {
        setSelectedAddress(selectedIndex);
      }
    }
  }, [userAddress]);

  const handleSelectAddress = (addressId, index) => {
    const updatedCheckedAddresses = Object.keys(checkedAddresses).reduce(
      (acc, id) => {
        acc[id] = id === addressId ? true : false;
        return acc;
      },
      {}
    );

    setCheckedAddresses(updatedCheckedAddresses);
    setSelectedAddress(index);
    dispatch(setCurrentAddress(user.userId, addressId));
  };

  const handleNewAddress = () => {
    setSelectedAddressData(null);
    setDialogOpen(true);
  };

  const handleEditAddress = (address) => {
    setSelectedAddressData(address);
    setDialogOpen(true);
  };

  return (<>
    {view != "cart" ?(
    <Main>
      <Box component='main' sx={{ flexGrow: 1, p: 3 }}>
        {user.role !== 'seller' && userAddress?.address?.length < 3 && (
          <div className='row mb-3 justify-content-end'>
            <div className='col-12 d-flex justify-content-end'>
              <Button
                variant='contained'
                color='success'
                startIcon={<AddCircleIcon />}
                onClick={handleNewAddress}
              >
                New Address
              </Button>
            </div>
          </div>
        )}
        <Grid container spacing={3}>
          {userAddress?.address?.map((addr, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                sx={{
                  boxShadow: 3,
                  borderRadius: 2,
                  border:
                    selectedAddress === index ? '2px solid #327136' : 'none',
                }}
              >
                <CardContent>
                  <FormControlLabel
                    control={
                      <Radio
                        checked={checkedAddresses[addr._id] || false}
                        onChange={() => handleSelectAddress(addr._id, index)}
                        color='success'
                      />
                    }
                    label={
                      <h6 style={{ color: '#327136', margin: 0 }}>
                        Address {index + 1}
                      </h6>
                    }
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      width: '100%',
                    }}
                  />

                  {addr.homeName && (
                    <h6>
                      <strong>Home Name:</strong> {addr.homeName}
                    </h6>
                  )}
                  {addr.companyName && (
                    <h6>
                      <strong>Company Name:</strong> {addr.companyName}
                    </h6>
                  )}

                  {[
                    { label: 'Do/No', value: addr.doorNumber || '-' },
                    { label: 'Street', value: addr.street || '-' },
                    { label: 'Town/City', value: addr.townOrCity || '-' },
                    { label: 'State', value: addr.state || '-' },
                    { label: 'Country', value: addr.country || '-' },
                    { label: 'Pincode', value: addr.pincode || '-' },
                    { label: 'Landmark', value: addr.landMark || '-' },
                  ].map((item, i) => (
                    <h6 key={i}>
                      <strong>{item.label}:</strong> {item.value}
                    </h6>
                  ))}
                </CardContent>
                <CardActionArea>
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                      variant='contained'
                      color='success'
                      endIcon={<ModeEditIcon />}
                      fullWidth
                      onClick={() => handleEditAddress(addr)}
                    >
                      Edit
                    </Button>
                  </Box>
                </CardActionArea>
              </Card>
              {selectedAddress === index && (
                <Typography variant='body2' color='success.main' sx={{ mt: 1 }}>
                  ✅ This address will be used for shipping.
                </Typography>
              )}
            </Grid>
          ))}
        </Grid>
      </Box>

      <NewAddress
        open={dialogOpen}
        handleClose={() => {
          setDialogOpen(false);
          setSelectedAddressData(null);
        }}
        addressData={selectedAddressData}
      />
    </Main>
    ):(<>
        <Box component='main' >
        {user.role !== 'seller' && userAddress?.address?.length < 3 && (
         
            <div className='col-12 mb-3'>
              <Button
                variant='contained'
                color='success'
                startIcon={<AddCircleIcon />}
                onClick={handleNewAddress}
              >
                New Address
              </Button>
           
          </div>
        )}
        <Grid container spacing={3}>
          {userAddress?.address?.map((addr, index) => (
            <Grid item xs={12} sm={12} md={12} key={index}>
              <Card
                sx={{
                  boxShadow: 3,
                  borderRadius: 2,
                  border:
                    selectedAddress === index ? '2px solid #327136' : 'none',
                }}
              >
                <CardContent>
                  <FormControlLabel
                    control={
                      <Radio
                        checked={checkedAddresses[addr._id] || false}
                        onChange={() => handleSelectAddress(addr._id, index)}
                        color='success'
                      />
                    }
                    label={
                      <h6 style={{ color: '#327136', margin: 0 }}>
                        Address {index + 1}
                      </h6>
                    }
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      width: '100%',
                    }}
                  />

                  {addr.homeName && (
                    <h6>
                      <strong>Home Name:</strong> {addr.homeName}
                    </h6>
                  )}
                  {addr.companyName && (
                    <h6>
                      <strong>Company Name:</strong> {addr.companyName}
                    </h6>
                  )}

                  {[
                    { label: 'Do/No', value: addr.doorNumber || '-' },
                    { label: 'Street', value: addr.street || '-' },
                    { label: 'Town/City', value: addr.townOrCity || '-' },
                    { label: 'State', value: addr.state || '-' },
                    { label: 'Country', value: addr.country || '-' },
                    { label: 'Pincode', value: addr.pincode || '-' },
                    { label: 'Landmark', value: addr.landMark || '-' },
                  ].map((item, i) => (
                    <h6 key={i}>
                      <strong>{item.label}:</strong> {item.value}
                    </h6>
                  ))}
                </CardContent>
                <CardActionArea>
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                      variant='contained'
                      color='success'
                      endIcon={<ModeEditIcon />}
                      fullWidth
                      onClick={() => handleEditAddress(addr)}
                    >
                      Edit
                    </Button>
                  </Box>
                </CardActionArea>
              </Card>
              {selectedAddress === index && (
                <Typography variant='body2' color='success.main' sx={{ mt: 1 }}>
                  ✅ This address will be used for shipping.
                </Typography>
              )}
            </Grid>
          ))}
        </Grid>
      </Box>

      <NewAddress
        open={dialogOpen}
        handleClose={() => {
          setDialogOpen(false);
          setSelectedAddressData(null);
        }}
        addressData={selectedAddressData}
      />
    </>)}
    </>
  );
}

export default Address;
